import React, { useEffect, useState  } from 'react';
import SeoHelmet from "../components/SeoHelmet";
import ContactForm from "../components/ContactForm";
import slide1 from '../assets/img/project_bg.jpg';
import Icon1 from '../assets/img/icon1.png';
import Icon2 from '../assets/img/Shape.svg';
import ContactModal from "../components/ContactModal";
import CustomerSay from "../components/CustomerSay";

// Import all your industry images



import Get1 from '../assets/img/get_in_touch_bg.jpg';
import Get2 from '../assets/img/get_in_img.svg';



import Project1 from '../assets/img/project1.png';
import Project2 from '../assets/img/project2.png';
import Project3 from '../assets/img/project3.png';
import Project4 from '../assets/img/project4.png';
import Project5 from '../assets/img/project5.png';
import Project6 from '../assets/img/project6.png';

import User1 from '../assets/img/user_1.jpg';
import User2 from '../assets/img/user_2.jpg';
import User3 from '../assets/img/user_3.jpg';


const tabs = [
    { label: "Uniforms" },
    { label: "Furnishings" },
    { label: "Merchandise" },
];

const Aboutus = () => {
    const [activeTab, setActiveTab] = useState(0);

  
   
     const [activeVideo, setActiveVideo] = useState(null);
   
     const handleOpenModal = (videoSrc) => {
       setActiveVideo(videoSrc); // Set the active video source
     };
   
     const handleCloseModal = () => {
       setActiveVideo(null); // Clear the active video source
     };
   
     useEffect(() => {
   
       if (window.Swiper) {
   
    
         const custswiper = new window.Swiper(".customerslide", {
           loop: true,
           slidesPerView: 1,
           navigation: {
             nextEl: ".testi-button-next",
             prevEl: ".testi-button-prev",
           },
           pagination: {
             el: ".swiper-paginationnn",
             clickable: true,
           },
           breakpoints: {
             768: {
               slidesPerView: 3,
               spaceBetween: 30,
              slidesPerGroup: 3,
   
             },
             // You can add more breakpoints if needed
           },
   
         });
   
       }
   
   
   
   
     }, []);
   
     return (
        <>
         <ContactModal />
            <SeoHelmet />
            <section>
                <div className="swiper animeslide">
                    <div className="swiper-wrapper">

                        <div className="swiper-slide animeslide-slide slide1 design_banner" style={{ backgroundImage: `url(${slide1})` }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-12 banner_content">
                                        <div className="content-slide">
                                            <div data-animate="bottom" className="animeslide-heading">
                                                <h2>Our Projects</h2>
                                                <p>we specialise in creating uniforms that<br></br>
                                                    serve both purpose and poise. </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>
                    <div className="flex animeslide-bottom">
                        <div className="animeslide-pagination swiper-pagination"></div>
                    </div>
                </div>
            </section>
            <section className="brands_section industries_we_dress project_section">
                <div className="industries_we_dress_with_purpose" >
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="project_img">
                                    <img src={Project1} alt="" className='logom' />
                                    <h3></h3>
                                    <p></p>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="project_img">
                                    <img src={Project2} alt="" className='logom' />
                                    <h3></h3>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="project_img">
                                    <img src={Project3} alt="" className='logom' />
                                    <h3></h3>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="project_img">
                                    <img src={Project4} alt="" className='logom' />
                                    <h3></h3>
                                    <p></p>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="project_img">
                                    <img src={Project5} alt="" className='logom' />
                                   <h3></h3>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="project_img">
                                    <img src={Project6} alt="" className='logom' />
                                    <h3></h3>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="get_in_touch_section product_get" style={{ backgroundImage: `url(${Get1})` }}>
                <div className="container">
                    <div className="row get_in_touch">
                        <div className="col-sm-6 get_in_touch_left">
                            <div className="get_in_touch_lefts">
                                <div className="brands_content get_content" >
                                    <h2>Get In Touch</h2>
                                    <p>We’re here to help! Reach out with your questions, feedback, or<br></br> suggestions, and we’ll get back to you as soon as possible.”</p>
                                </div>
                                <img src={Get2} alt="" style={{width: '80%' }} className='get_in_touch' />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="get_in_touch_right">
                             <ContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
           <CustomerSay />

        </>
    );
};

export default Aboutus;
